import React, { useState } from "react";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";

import {
  MDBBreadcrumb, MDBBreadcrumbItem,
  MDBBtn,
  MDBIcon,
  MDBModalFooter,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import BlfSettings from "../components/topviews/phonesanddevices/BlfSettings";
import BlfUsers from "../components/topviews/phonesanddevices/BlfUsers";
import PopupLoader from "./popups/PopupLoader";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";
function BLFDetails(props) {
  const navigate = useNavigate();

  /*  const [selectVal, setSelectVal] = useState("africa");
   const [verticalActive, setVerticalActive] = useState("tab1");
 
   const handleVerticalClick = (value) => {
     if (value === verticalActive) {
       return;
     }
 
     setVerticalActive(value);
   }; */

  const location = useLocation();
  //console.log("Location ::::::::value : " + location.state.groupid);

  const [groupid] = useState(location.state?.groupid ?? "");
  const [groupInfo] = useState(location.state?.groupInfo ?? "");

  const [basicActive1, setBasicActive1] = useState("tab5");
  const [basicActive2, setBasicActive2] = useState("tab7");
  const [basicActive, setBasicActive] = useState("tab1");

  // let [basicActive1, setBasicActive1] = useState("tab5");
  // let setBasicActiveTab5 = () => setBasicActive1(basicActive1);
  const [isEdited, setIsEdited] = useState(false);
  const [loadAleart, setloadAleart] = useState(false);
  let toggleShow = () => setloadAleart(!loadAleart);
  const { isEdited: fieldEdited, setEdited: setFieldEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);

  const handleBasicClick1 = (value) => {

    if (value === "tab6" && isEdited) {
      setloadAleart(true);
      setBasicActive1("tab5");
    }
    else {
      if (fieldEdited) {
        setTargetView(value);
        setShowWarning(true);
        return;
      }
      setBasicActive1(value);
    }
  };
  const handleOk = () => {
    setFieldEdited(false);
    if (targetView.indexOf("/") !== -1) {
      const targetValues = targetView.split("#")
      if (targetValues.length > 1) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1] },
          }
        );

      } else {
        navigate(targetValues[0]);
      }

    } else {
      setBasicActive1(targetView);
    }
    setShowWarning(false);
  };
  const handleBasicClick2 = (value) => {
    if (value === basicActive2) {
      return;
    }

    setBasicActive2(value);
  };
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };
  // const [basicModal, setBasicModal] = useState(false);


  const [Adduser, setAdduser] = useState(false);
  const toggleShow20 = () => setAdduser(!Adduser);



  /*  const configuredDevices = {
     columns: ['Phone Name', 'User', 'Extension', 'Model', 'MAC Address', 'configuration Update', 'Online'],
     rows: [
       ['Nick VVX601', 'Nick Leyendecker', '3577', 'Poly VVX 601', '0004F21F3434', <span className="green-dot"></span>, <span className="green-dot"></span>],
       ['Pax T465', 'Michael paxton', '3760', 'Yealink T465', '001565C538FB', <span className="red-dot"></span>, <span className="green-dot"></span>],
     ],
   }; */

  /*   const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const section4 = useRef(null);
  
    const containerRef = useRef(null); */
  const redircttoPSLanding = () => {
    if (isEdited) {
      setTargetView("/pslanding#tab4");
      setShowWarning(true);
      return;
    }
    navigate("/pslanding", {
      state: { tab: "tab4" },
    });
    window.location.reload();
  }

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={10}
          content={
            <>

              <section className="mb-3">
                <div className="card card-height">

                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/huntgroup");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/huntgroup");
                            }}
                          >
                            <strong>{t("phoneSystem")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a onClick={redircttoPSLanding}>
                            <strong  >
                              <strong>{t("BLFGroups")}</strong>
                            </strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong>{groupInfo.groupname}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="p-2 fw-600">{groupInfo.groupname}</h5>
                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        <MDBTabs>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick1("tab5")}
                              active={basicActive1 === "tab5"}
                            >
                              {t("settings")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick1("tab6")}
                              active={basicActive1 === "tab6"}
                            >
                              {t("users")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                        </MDBTabs>
                        <MDBTabsContent>


                          {basicActive1 === "tab5" && <MDBTabsPane open={basicActive1 === "tab5"}
                            className="pt-2"
                          >
                            < BlfSettings groupInfo={groupInfo} setIsEdited={setIsEdited} setFieldEdited={setFieldEdited} />

                          </MDBTabsPane>}

                          {basicActive1 === "tab6" && <MDBTabsPane open={basicActive1 === "tab6"} setIsEdited={setIsEdited}>

                            <BlfUsers groupid={groupid} setFieldEdited={setFieldEdited} />

                          </MDBTabsPane>}



                        </MDBTabsContent>
                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                </div>

              </section>
              {loadAleart && (
                <PopupLoader
                  title="Warning"
                  content={
                    <>
                      <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                        <MDBIcon fas icon="exclamation-triangle" className="me-3 fs-5 mt-1" color="warning" />
                        <div>
                          There are unsaved changes. Are you sure you want to navigate away?
                        </div>
                      </div>

                      <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={() => {
                          // setBasicActive1("tab5"); 
                          // setIsEdited(true);
                          setloadAleart(false);
                        }}>
                          {t("cancel")}
                        </MDBBtn>
                        <MDBBtn color="primary" onClick={() => {
                          setBasicActive1("tab6");
                          setloadAleart(false);
                        }}>
                          {t("ok")}
                        </MDBBtn>
                      </MDBModalFooter>
                    </>
                  }
                  onShow={setloadAleart}
                  onClose={toggleShow}
                />
              )}
            </>
          }
        />
        {/* <Footer /> */}
        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
      </>
    </React.Fragment >
  );
}

export default BLFDetails;
